import { render, staticRenderFns } from "./OrderFormView.vue?vue&type=template&id=f5be4020&"
import script from "./OrderFormView.vue?vue&type=script&lang=js&"
export * from "./OrderFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports